import { AsyncPipe } from '@angular/common';
import { Component, OnInit, inject } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { AcceptContractPageBase } from '@zero/self-service/feature-crypto-onboarding/base';
import { TransactionAuthorizationComponent, UserMessagesComponent } from '@zero/shared/ui-web-components';
import { ButtonComponent } from '@zero/shared/ui-web-design-system';
import { UserMessagesHolderService } from '@zero/shared/util-web-app-services';
import { environment } from 'environments/environment';
import { map } from 'rxjs';

@Component({
  templateUrl: './accept-contract-page.component.html',
  imports: [TransactionAuthorizationComponent, UserMessagesComponent, AsyncPipe, ButtonComponent],
})
export class AcceptContractPageComponent extends AcceptContractPageBase implements OnInit {
  public readonly messageService = inject(UserMessagesHolderService);
  readonly #sanitizer = inject(DomSanitizer);

  public readonly previewFileUrl$ = this.cryptoOnboardingFacade.addressConfirmed$.pipe(
    map((addressConfirmed) => {
      return this.#sanitizer.bypassSecurityTrustUrl(
        `${environment.apihost}/api/kryptoonboarding/agreementpdf/Sonderbedingungen_Kryptohandel.pdf?awc=${addressConfirmed}`,
      );
    }),
  );
  public readonly contractPreviewFileUrl$ = this.cryptoOnboardingFacade.addressConfirmed$.pipe(
    map((addressConfirmed) => {
      return this.#sanitizer.bypassSecurityTrustUrl(
        `${environment.apihost}/api/kryptoonboarding/contractpdf/Rahmenvertrag_Anlage-und_Abschlussvermittlung.pdf?awc=${addressConfirmed}`,
      );
    }),
  );

  public ngOnInit(): void {
    this.messageService.clearAllMessages();
  }
}
